// extracted by mini-css-extract-plugin
export default {"googleLogoutButton":"Navbar_googleLogoutButton__ZyjU8"};